var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8462 2H11.1538C6.05385 2 2 6.04722 2 11.1389V26.8055C2 31.8972 6.05385 35.9444 11.1538 35.9444H26.8462C31.9462 35.9444 36 31.8972 36 26.8055V11.1389C36 6.04722 31.9462 2 26.8462 2Z",
    stroke: "white",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1541 9.83328C28.8763 9.83328 29.4618 9.24876 29.4618 8.52772C29.4618 7.80668 28.8763 7.22217 28.1541 7.22217C27.4318 7.22217 26.8464 7.80668 26.8464 8.52772C26.8464 9.24876 27.4318 9.83328 28.1541 9.83328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.8056C23.3333 26.8056 26.8462 23.2985 26.8462 18.9722C26.8462 14.646 23.3333 11.1389 19 11.1389C14.6667 11.1389 11.1539 14.646 11.1539 18.9722C11.1539 23.2985 14.6667 26.8056 19 26.8056Z",
    stroke: "white",
    strokeWidth: 2.61111,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagramlogo.aa2dea741ffb55054877ce058081783a.svg";
export { ForwardRef as ReactComponent };